import { AddFilled } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../../../hooks/useNavigateTo";
import "./YourDeliveriesHeadline.scss";

interface YourDeliveriesHeadlineProps {
  count: number;
}

const YourDeliveriesHeadline = (props: YourDeliveriesHeadlineProps) => {
  const { t } = useTranslation();
  const { navigateToNewOrder } = useNavigateTo();
  const { count } = props;

  return (
    <div className="your-deliveries">
      <div className="your-deliveries-text">
        {t("yourDeliveries")} {count}
      </div>
      <div className="your-deliveries-icon">
        <AddFilled size={32} onClick={() => navigateToNewOrder()} />
      </div>
    </div>
  );
};
export default YourDeliveriesHeadline;
